import Checkbox, {CheckboxSizeOptions} from "../../forms/checkbox/Checkbox";
import React, {useMemo, useState} from "react";
import {Button} from "antd";
import MovingBoxesIllustration from "../../../assets/illustrations/MovingBoxesIllustration";
import {CouponApprovalStatus} from "./PresetsModal";
import useAppContext from "../../../hooks/useAppContext";
import {DISCOUNT_RATE_FOR_ALL} from "./PresetsModalContent";
import {FlowProps} from "../../../types/FlowProps";
import {MessageTemplateProps} from "../../../types/MessageTemplateProps";

interface PresetsExtraActionsProps {
    onBack: () => void;
    onSubmit: (shouldCreateDiscounts: boolean, shouldDisableOldTemplates: boolean) => void;
    couponApprovalStatus: CouponApprovalStatus;
    flowId: number;
    isLoading: boolean;
}

const PresetsExtraActions = ({ onBack, onSubmit, flowId, couponApprovalStatus, isLoading }: PresetsExtraActionsProps) => {
    const [shouldSetDiscountForAll, setShouldSetDiscountForAll] = useState(false);
    const [disablePreviousTemplates, setDisablePreviousTemplates] = useState(false);
    const { data: { templates, flows } } = useAppContext();
    const previousActiveTemplates = useMemo(() => flows.data.find((flow: FlowProps) => flow.id === flowId)?.templates.filter((template: MessageTemplateProps) => template.active), [flows.data]);

    const onChangeCouponsApproval = () => {
        setShouldSetDiscountForAll(!shouldSetDiscountForAll);
    }

    const onChangeTemplateDisable = () => {
        setDisablePreviousTemplates(!disablePreviousTemplates);
    }

    return (
        <div className="presets-extra-actions-container">
            <div className="top">
                <div className="title">
                    Before we create your new templates...
                </div>
                <div className="sub-title">
                    Please go over the issues we found, and check the issues you want us to fix:
                </div>
                <div className="sections">
                    <div className="left">
                        {(couponApprovalStatus?.totalApproved || 0) < (couponApprovalStatus?.total || 0) ? <Checkbox label={`Add Permission to Create ${DISCOUNT_RATE_FOR_ALL}% Coupon for Abandoned Cart Recovery`} description={`Your new messaging plan includes templates with coupon codes to enhance cart recovery. To enable coupon creation for abandoned carts, please approve a 3% discount for all products. Without this approval, we cannot generate coupons, and messages with them won’t be sent to clients. You can update this setting anytime in the Coupons section on the Templates page to customize discounts per product. Currently, ${couponApprovalStatus.totalApproved} products are approved for a discount, out of ${couponApprovalStatus.total} products in store`} size={CheckboxSizeOptions.big} isSelected={shouldSetDiscountForAll} setIsSelected={onChangeCouponsApproval} /> : null}
                        {previousActiveTemplates ? <Checkbox label="Deactivate Previous Active Template" description="Previously added and active templates may not work well with the new Message Plan. Would you like to deactivate all previous active templates?" size={CheckboxSizeOptions.big} isSelected={disablePreviousTemplates} setIsSelected={onChangeTemplateDisable} /> : null}
                    </div>
                    <div className="right">
                        <MovingBoxesIllustration />
                    </div>
                </div>
            </div>
            <div className="action-bar">
                <Button type="text" size="large" onClick={onBack} disabled={isLoading}>Back</Button>
                <Button type="primary" size="large" loading={isLoading} onClick={() => onSubmit(shouldSetDiscountForAll, disablePreviousTemplates)} >Continue</Button>
            </div>
        </div>
    );
}

export default PresetsExtraActions;